var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHandshakeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.816 62.06",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".handshake_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:3}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.413 1.058)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "handshake_icon_svg__a",
    d: "M0 17.595l9.651 10.321M78.139 3.727L71.6 9.566 55.934.721a5.59 5.59 0 00-5.4-.052L27.907 13.095a1.091 1.091 0 00-.395 1.546l1.76 2.8a2.516 2.516 0 002.576 1.125L49.021 14.9a5.659 5.659 0 015.573 1.966l17.68 21.774a3.435 3.435 0 01-.412 4.731l-2.645 2.3a3.435 3.435 0 01-4.894-.421L52.379 30.594M27.658 13.172l-8.372-9.385M93.99 21.175l-6.68 6.011s-1.022 8.157-7.221 10.965"
  }), /*#__PURE__*/React.createElement("path", {
    className: "handshake_icon_svg__a",
    d: "M45.303 37.701l10.424 12.78a3.435 3.435 0 004.816.473l2.379-1.958a3.435 3.435 0 00.489-4.774l-6.739-8.381"
  }), /*#__PURE__*/React.createElement("path", {
    className: "handshake_icon_svg__a",
    d: "M39.542 45.802l7.616 9.282a3.435 3.435 0 004.826.455l2.087-1.717a3.435 3.435 0 00.464-4.791l-8.167-10.047"
  }), /*#__PURE__*/React.createElement("path", {
    className: "handshake_icon_svg__a",
    d: "M37.782 58.494l.24.3a3.435 3.435 0 004.8.421l1.975-1.683a3.435 3.435 0 00.464-4.791l-5.719-6.973"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "handshake_icon_svg__a",
    width: 8.63,
    height: 8.63,
    rx: 2.6,
    transform: "rotate(49.18 -22.601 28.183)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "handshake_icon_svg__a",
    width: 8.595,
    height: 8.595,
    rx: 2.6,
    transform: "rotate(49.18 -26.844 37.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "handshake_icon_svg__a",
    width: 8.595,
    height: 8.595,
    rx: 2.6,
    transform: "rotate(49.18 -31.133 46.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "handshake_icon_svg__a",
    d: "M31.79 47.993l1.88 2.177a2.233 2.233 0 01-.23 3.15l-2.177 1.88a2.233 2.233 0 01-3.148-.23l-3.368-3.9 3.899-3.367a2.233 2.233 0 013.144.29z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHandshakeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/handshake_icon.56f86e5a46b40127b7101af7c0118c78.svg";